<template>
  <BasicAlert
    alertLabel="Les champs avec * sont obligatoires."
    class="form--mandatory"
  />
  <InformationSalarieSection />
  <CoordonneesSalarieSection />
  <TuteurSection />
  <TuteurEntrepriseUtilisatriceSection />
  <TuteurAttestationSection />
</template>

<script setup lang="ts">
  import InformationSalarieSection from './sections/informationSalarie/InformationSalarieSection.vue'
  import TuteurSection from './sections/tuteur/TuteurSection.vue'
  import TuteurEntrepriseUtilisatriceSection from './sections/tuteur/TuteurEntrepriseUtilisatriceSection.vue'
  import TuteurAttestationSection from './sections/tuteur/TuteurAttestationSection.vue'
  import CoordonneesSalarieSection from './sections/coordonneesSalarie/CoordonneesSalarieSection.vue'
</script>
